import { default as module } from './AbstractModule';
import { html } from '../utils/environment'

const CLASS = {
    OPENREEL: `has-video-reel-open`,
    SHOWTEASE: `has-video-reel-tease`,
    ACTIVE: `-active`,
    HOLD: `-hold`
}

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'toggleReel',
            mouseenter: 'mouseEnter',
            mouseleave: 'mouseLeave',
        }
    }

    init(){
        this.isOpen = false
    }

    mouseEnter() {
        if (!isMobile) {
            this.call('playVideo', null, 'Videoreel')
            html.classList.add(CLASS.SHOWTEASE)
            html.classList.add(CLASS.ACTIVE)
            html.classList.add(CLASS.HOLD)

            this.hoverTimeout = setTimeout(() => {
                this.open();

            }, 1000);
        }
    }

    mouseLeave() {
        if (!isMobile) {
            clearTimeout(this.hoverTimeout)
            if(!this.isOpen) {
                html.classList.remove(CLASS.SHOWTEASE)
                html.classList.remove(CLASS.ACTIVE)
                html.classList.remove(CLASS.HOLD)
                this.call('pausedVideo', null, 'Videoreel')
            }
        }
    }

    toggleReel() {
        if(this.isOpen) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        clearTimeout(this.hoverTimeout)

        if (isMobile) {
            this.call('playVideo', null, 'Videoreel')
        }

        this.isOpen = true
        html.classList.add(CLASS.OPENREEL)
        html.classList.remove(CLASS.SHOWTEASE)
        html.classList.remove(CLASS.ACTIVE)
        html.classList.remove(CLASS.HOLD)
    }

    close() {
        this.call('pausedVideo', null, 'Videoreel')

        this.isOpen = false
        html.classList.remove(CLASS.OPENREEL)
    }
}
